module.exports = __webpack_public_path__ + "static/media/teacher10.0cd9db4c.png";